const probeTypes = [
  "K",
  "J",
  "T",
  "N",
  "S",
  "E",
  "B",
  "R",
];

export default probeTypes;
